import {Component, inject, input, signal, ChangeDetectionStrategy} from "@angular/core"
import {RouterLink} from "@angular/router"
import {AssetBoxesFragment} from "@app/platform/components/assets/asset-boxes/asset-boxes.generated"
import {DataObjectThumbnailComponent} from "@common/components/data-object-thumbnail/data-object-thumbnail.component"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {DownloadResolution} from "@generated"
import {Labels} from "@labels"
import {AssetBoxesGQL} from "@platform/components/assets/asset-boxes/asset-boxes.generated"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-asset-boxes",
    imports: [RouterLink, DataObjectThumbnailComponent],
    templateUrl: "./asset-boxes.component.html",
    styleUrl: "./asset-boxes.component.scss",
})
export class AssetBoxesComponent {
    readonly $assetId = input.required<string>({alias: "assetId"})

    readonly $asset = signal<AssetBoxesFragment | undefined>(undefined)

    readonly assetBoxes = inject(AssetBoxesGQL)

    protected readonly Labels = Labels

    ngOnInit() {
        fetchThrowingErrors(this.assetBoxes)({assetId: this.$assetId()}).then(({asset}) => {
            this.$asset.set(asset)
        })
    }

    protected readonly DownloadResolution = DownloadResolution
}
